import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Table,
  Spinner,
} from "reactstrap";
import swal from "sweetalert2";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import showNotification from "../../../../helpers/show_notification";
import {
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const animatedComponents = makeAnimated();

const BranchwiseItemExpiringInventoriesReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [filteredOrders, setFilteredOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setFilteredOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setFilteredOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }
    try {
      setIsLoadingOrders(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_expiring_items";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const rows = (response.data || []).map((row, index) => ({
          ...row,
          row_key: row._id || `row_${index}`,
          item_name: row.item_details && row.item_details.name,
          item_category: row.item_details && row.item_details.category,
          item_sub_category: row.item_details && row.item_details.sub_category,
        }));
        setAllOrders(rows);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      showNotification(
        typeof error === "string"
          ? error
          : "Sorry! something went wrong, please contact our support team",
        "Error",
      );
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  useEffect(() => {
    setFilteredOrders(allOrders);
  }, [allOrders]);

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      footer: true,
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Branch"),
      dataField: "store_name",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.store_name)
                .map((row) => [
                  row.store_name,
                  { value: row.store_name, label: row.store_name },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Item"),
      dataField: "item_name",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.item_name)
                .map((row) => [
                  row.item_name,
                  { value: row.item_name, label: row.item_name },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },

    {
      text: props.t("Category"),
      dataField: "item_category",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.item_category)
                .map((row) => [
                  row.item_category,
                  { value: row.item_category, label: row.item_category },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Sub-Category"),
      dataField: "item_sub_category",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.item_sub_category)
                .map((row) => [
                  row.item_sub_category,
                  {
                    value: row.item_sub_category,
                    label: row.item_sub_category,
                  },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      footer: true,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Cost"),
      dataField: "total_cost",
      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),

      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Expiry"),
      dataField: "expiry_date",
      formatter: (cell, row, rowIndex) => {
        return row.expiry_date
          ? moment(row.expiry_date).format("YYYY-DD-MM HH:mm ")
          : "";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "item_category",
      order: "asc",
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  function afterFilter(newResult, newFilters) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "branchwise_item_expiring_report_" + dateFrom + dateTo;
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          BranchName: v.store_name,
          Items: v.item_name,
          Category: v.item_category,
          SubCategory: v.item_sub_category,
          Batch: v.batch,
          Quantity: ExportAvailableInCSVForReports(v.quantity),
          Cost: v.total_cost,
          Expiry: v.expiry_date
            ? moment(v.expiry_date).format("DD/MM/YYYY HH:mm")
            : "",
        });
      });
      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branchwise Expiring Item Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branchwise Expiring Item Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>{" "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Expiring Item Report")}{" "}
                    </CardTitle>

                    <ToolkitProvider
                      keyField="row_key"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            filter={filterFactory({ afterFilter })}
                            condensed
                            defaultSorted={defaultSorted}
                            rowStyle={rowStyle}
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {},
  )(withNamespaces()(BranchwiseItemExpiringInventoriesReport)),
);
